import React from 'react';

const MediaRecording = ({ caption, preview_source: previewSource }) => {
  return (
    <div>
      <div className="ai-c d-f fd-c MediaRecording">
        <iframe
          title="Recording Embed"
          allowFullScreen
          width="100%"
          height="100%"
          allowtransparency="true"
          scrolling="no"
          style={{ backgroundColor: 'transparent' }}
          frameBorder="0"
          src={previewSource}
        />
      </div>
      <figcaption>
        <p>{caption}</p>
      </figcaption>
    </div>
  );
};

export default MediaRecording;
